import Loader from "components/elements/Loader/Loader";
import {
  ChangeEventHandler,
  FormEventHandler,
  useEffect,
  useMemo,
  useState,
} from "react";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import { apiRequest, setOnboarding, setUser, getUser } from "utils/service";

const ExamType = () => {
  const user = getUser();
  const [, forceUpdate] = useState("");
  const [examTypes, setExamTypes] = useState<
    { exam_id: string; exam_name: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    exam_type_id: "",
  });
  const validator = useMemo(
    () =>
      new SimpleReactValidator({
        autoForceUpdate: { forceUpdate },
      }),
    [forceUpdate]
  );

  const handleFormSubmit: FormEventHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      setLoading(true);
      apiRequest("exam_type_submit", formData)
        .then((resp) => {
          if (resp.success === "true") {
            toast.success(resp.message);
            console.log(resp);
            const updatedOnboardingData = { path: "select-group" };
            setOnboarding(updatedOnboardingData);
            setUser({ ...user, exam_type_id: formData.exam_type_id });
            window.location.href = updatedOnboardingData.path;
          } else {
            toast.error(resp.message);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      validator.showMessages();
    }
  };

  const getExamTypes = () => {
    apiRequest("exam_type", {}, "get").then((resp) => {
      if (resp.success === "true") {
        setExamTypes(resp.data);
      }
    });
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getExamTypes();
  }, []);

  const instruction = `1. Any One Subject Subsciption is Free for 2 Days.<br />

  Select any One Subject from:<br />

  CA Inter: Advanced A/c, AS Advanced A/c, Costing, FM & SM<br />

  CA Final: FR, SFM Audit & Direct Tax<br />

2. Appearing Single Group 1 - Select Option from Group 1 only.<br />

3. Appearing Single Group 2 - Select Option from Group 2 only.<br />

4. Appearing for Both Groups 1 & 2 - Select Option from Group 1 & 2 only.<br />

For Paid Subscription - After Login Please Select Profile & Subscription.<br />

Contact: 9870942020 / 9821342020`;
  return (
    <div className="login-container">
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card col-6">
          <div className="card-header">
            <h3>Preparing For</h3>
          </div>
          <div className="card-body">
            <form
              onSubmit={handleFormSubmit}
              className="d-flex flex-column gap-2"
            >
              <div className="row">
                <div className="col-8 offset-2 d-flex flex-column align-items-center">
                  {examTypes.map(({ exam_name, exam_id }) => (
                    <div className="w-100" key={exam_id}>
                      <div className="form-check d-flex justify-content-start flex-column">
                        <div className="d-flex text-start">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="exam_type_id"
                            value={exam_id}
                            id={`exam_radio_${exam_id}`}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label text-white ms-2"
                            htmlFor={`exam_radio_${exam_id}`}
                          >
                            {exam_name}
                          </label>
                        </div>
                        <div className="d-flex">
                          {validator.message("exam type", formData.exam_type_id, "required", {
                            className: "text-danger",
                          })}
                        </div>
                      </div>
                    </div>

                  ))}
                </div>
              </div>

              <div className="form-group">
                <input
                  disabled={loading}
                  type="submit"
                  value="Submit"
                  className="btn float-right login_btn mt-4"
                />
              </div>
              <div className="form-group text-start">
                <h6 className="text-white">Please Read Carefully Before Registration:</h6>
                <small className="text-white" dangerouslySetInnerHTML={{ __html: instruction }}>
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamType;
